import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import Common from 'src/components/Common';
import { getMessageStyle, getReplySpacerStyle, getTimestampStyle } from './style';
import Attachment from './Attachment';
import Text from './Text';
import UserAvatar from 'react-native-user-avatar';
import styles, { getAvatar } from './style';
import { nameToInitials } from 'src/utils';
import { avatarBgColors, colors } from 'src/constants/theme';
import { formatDate } from 'src/utils/date';
import useProfile from 'src/hooks/useProfile';
import useTheme from 'src/hooks/useTheme';

const renderSystemMessage = (message) => (
  <Common.Row justifyContent="center" style={styles.systemMessage}>
    <Common.Text color={colors.grey3} size={14}>
      {message?.message}
    </Common.Text>
  </Common.Row>
);
const Message = ({ index, message, messagesLength }) => {
  if (message.attributes?.is_internal || !message.message) return null;
  if (message.type === 'system') return renderSystemMessage(message);
  const { companyInfo } = useProfile();
  const { colors: themeColors, theme, isDarkMode } = useTheme();
  const isMine = message.isMine;
  const author = message.attributes?.author;
  const user_type = message.attributes?.user_type;
  const isTextMessage = message.type === 'text';
  const attachment = message.attachment;
  const isImage = !isTextMessage && (attachment?.file.type || message.message?.contentType).includes('image');

  const messageTimeLabel = useMemo(
    () => (
      <Common.Text
        style={getTimestampStyle({
          isImage,
        })}
        size={11}
        transform="uppercase"
        color={colors.grey}
      >
        {formatDate(message.timestamp || new Date(), 'hh:mm a')}
      </Common.Text>
    ),
    [message.timestamp],
  );

  return (
    <Common.View style={[styles.wrapper, index === 0 && { marginTop: 0 }, isMine && styles.mineWrapper]}>
      {!isMine && (
        <>
          {!author || user_type === 'system' ? (
            <Common.Avatar source={getAvatar(companyInfo)} />
          ) : (
            <UserAvatar
              textColor="lightslategrey"
              size={37}
              name={nameToInitials(author?.toUpperCase())}
              bgColors={avatarBgColors}
            />
          )}
        </>
      )}
      <Common.View
        style={getMessageStyle({
          theme,
          themeColors,
          isDarkMode,
          isMine,
          isTextMessage,
        })}
      >
        {isTextMessage ? (
          <>
            <Text message={message} />
            {messageTimeLabel}
          </>
        ) : (
          <Attachment
            message={message.message || {}}
            attachment={attachment}
            isMine={isMine}
            isImage={isImage}
            author={author}
            messageTimeLabel={messageTimeLabel}
          />
        )}
      </Common.View>
      {index === messagesLength && <Common.View style={getReplySpacerStyle(message.quickReplies?.values?.length)} />}
    </Common.View>
  );
};

Message.propTypes = {
  message: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  messagesLength: PropTypes.number.isRequired,
};

export default memo(Message);
